export default __webpack_public_path__ + "static/media/buy-course.67d7549d.svg";